<template>
    <!-- ion-select v-if fixes delayed options in ionic/vue : -->
    <!-- https://github.com/ionic-team/ionic-framework/issues/19324#issuecomment-595821104 -->
    <ion-select
        :compare-with="(i, j) => i.id === j.id"
        :value="modelValue"
        @ionChange="$emit('update:modelValue', $event.detail.value)"
        :placeholder="placeholder"
        v-if="users.length > 0"
    >
        <ion-select-option :value="user" :key="user.id" v-for="user in users">
            {{ user.name }}
        </ion-select-option>
    </ion-select>
</template>

<script>
import {
    IonSelect,
    IonSelectOption
} from '@ionic/vue';
import _ from 'lodash';
export default {
    name: "UserSelect",
    inject: ['$http', '$toast', '$validationAlert'],
    components: {
        IonSelect, IonSelectOption
    },
    emits: [
        'update:modelValue'
    ],
    props: {
        modelValue: Object,
        permission: String,
        placeholder: {
            type: String,
            default: 'Please select'
        }
    },
    computed: {
        userId() {
            if (this.users.length < 1) {
                return null;
            }
            if (this.modelValue && this.modelValue.id) {
                return this.modelValue.id;
            }
            return null;
        }
    },
    mounted() {
        this.$http.get('/api/users', {
            params: {permissions: this.permission, all: true, orderBy: 'name'}
        }).then(response => {
            this.users = response.data.items;
        }).catch(error => {
            this.$validationAlert(error);
        })
    },
    data() {
        return {
            users: []
        }
    }
}
</script>

<style scoped>

</style>
